var saving =  document.getElementsByClassName('saving-wrapper');
if (saving.length > 0){
  document.querySelectorAll('.quantity__button').forEach(item => {
      item.addEventListener('click', event => {
          change_packet_info();
      })
    })
  document.querySelector('.quantity__input').addEventListener('change', event => {
    change_packet_info();
  })
}
var saving =  document.getElementsByClassName('custom-saving-wrapper');
if (saving.length > 0){
  document.querySelectorAll('.quantity__button').forEach(item => {
      item.addEventListener('click', event => {
          change_packet_info();
      })
    })
  document.querySelector('.quantity__input').addEventListener('change', event => {
    change_packet_info();
  })
}

function change_packet_info(){
  // Update every .custom-saving-wrapper on the page, if any exist
  if (document.querySelector('.custom-saving-wrapper')) {
    let quantity_meters = document.querySelector('.main_product-quantity_input');
    let measurement_value = parseFloat(quantity_meters.getAttribute('data-reference-value'));
    let total_meters = Math.ceil(quantity_meters.value / measurement_value);
    let packet_price = parseFloat(quantity_meters.getAttribute('data-packet-price'));
    let total_packet_price = (packet_price * 1.19 * total_meters / 100).toFixed(2);
    total_packet_price = total_packet_price.toString();

    document.querySelectorAll('.custom-saving-wrapper').forEach(function(wrapper){
      var savingEl = wrapper.querySelector('.saving');
      var totalMetersEl = wrapper.querySelector('.total_meters');
      var totalPacketPriceEl = wrapper.querySelector('.total_packet_price');
      var totalMultipleEl = wrapper.querySelector('.total_multiple');

      if (totalMetersEl) totalMetersEl.innerHTML = total_meters + ' ';
      if (totalPacketPriceEl) totalPacketPriceEl.innerHTML = total_packet_price.replace('.', ',');

      if (savingEl) {
        var saved = savingEl.getAttribute('data-saved');
        if (saved) {
          saved = saved.replace('€', '').replace(',', '.');
          var packet_strike_price = Number(saved);
          packet_strike_price = (Math.round((packet_strike_price * total_meters) * 100) / 100).toFixed(2);
          packet_strike_price = (packet_strike_price + '').replace('.', ',') + ' €';
          var spanEl = savingEl.querySelector('span');
          if (spanEl) spanEl.innerHTML = packet_strike_price;
        }
      }

      if (totalMultipleEl) {
        totalMultipleEl.innerHTML = total_meters > 1 ? 'Pakete' : 'Paket';
      }

      // NEW: only show the dynamic box once more than 1 package is selected
      var dynamicCell = wrapper.closest('.js-dynamic-packet-cell');
      if (dynamicCell) {
        dynamicCell.style.display = total_meters > 1 ? '' : 'none';
      }
    });
  }
  // ALSO update every .saving-wrapper on the page, if any exist — independent of the above
  if (document.querySelector('.saving-wrapper')) {
    let quantity_meters = document.querySelector('.main_product-quantity_input') || document.querySelector('.quantity__input');
    if (!quantity_meters) return;
    let measurement_value = parseFloat(quantity_meters.getAttribute('data-reference-value')) || 1;
    let current_qty = parseFloat(quantity_meters.value) || 1;
    let total_meters = Math.ceil(current_qty / measurement_value);
    let packet_price = parseFloat(quantity_meters.getAttribute('data-packet-price')) || 0;
    let packet_strike_price = parseFloat(quantity_meters.getAttribute('data-compare-at-price')) || 0;
    let total_packet_price = (packet_price * 1.19 * total_meters / 100).toFixed(2);
    let total_strike_price = (packet_strike_price * total_meters / 100 - total_packet_price).toFixed(2);
    total_packet_price = total_packet_price.toString();
    total_strike_price = total_strike_price.toString();

    let totalMetersEl = document.querySelector('.saving-wrapper .total_meters');
    if (totalMetersEl) totalMetersEl.innerHTML = total_meters + ' ';

    let totalPacketPriceEl = document.querySelector('.saving-wrapper .total_packet_price');
    if (totalPacketPriceEl) totalPacketPriceEl.innerHTML = total_packet_price.replace('.', ',');

    let savingLine = document.querySelector('.saving-wrapper .saving');
    if (savingLine) {
      let spanEl = document.querySelector('.saving-wrapper .saving span');
      if (spanEl) spanEl.innerHTML = total_strike_price.replace('.', ',');
    }

    let totalMultipleEl = document.querySelector('.saving-wrapper .total_multiple');
    if (totalMultipleEl) {
      totalMultipleEl.innerHTML = total_meters > 1 ? 'Pakete' : 'Paket';
    }
  }
  // else {
  //   // let quantity_meters = document.querySelector('.main_product-quantity_input');
  //   let quantity_meters = document.querySelector('.main_product-quantity_input') || document.querySelector('.quantity__input');
  //   if (!quantity_meters) return; // Exit if the element isn't found
  //   let measurement_value = parseFloat(quantity_meters.getAttribute('data-reference-value')) || 1;
  //   let current_qty = parseFloat(quantity_meters.value) || 1;
  //   let total_meters = Math.ceil(current_qty / measurement_value);
  //   let packet_price = parseFloat(quantity_meters.getAttribute('data-packet-price')) || 0;
  //   let packet_strike_price = parseFloat(quantity_meters.getAttribute('data-compare-at-price')) || 0;
  //   let total_packet_price = (packet_price * 1.19 * total_meters / 100).toFixed(2);
  //   let total_strike_price = (packet_strike_price * total_meters /100 - total_packet_price).toFixed(2);
  //   total_packet_price = total_packet_price.toString();
  //   total_strike_price = total_strike_price.toString();
  //   document.querySelector('.saving-wrapper .total_meters').innerHTML = total_meters + ' ';
  //   document.querySelector('.saving-wrapper .total_packet_price').innerHTML = total_packet_price.replace('.', ',');
  //   let savingLine =  document.querySelector('.saving-wrapper .saving');
  //   if (savingLine){
  //     document.querySelector('.saving-wrapper .saving span').innerHTML = total_strike_price.replace('.',',');
  //   }
  //   if(total_meters > 1){
  //     document.querySelector('.saving-wrapper .total_multiple').innerHTML = 'Pakete';
  //   }else{
  //     document.querySelector('.saving-wrapper .total_multiple').innerHTML = 'Paket';
  //   }
  // }
      else {
      // This branch runs when .saving-wrapper is NOT on the page, so every
      // '.saving-wrapper …' lookup is guarded against null before writing innerHTML.
      let quantity_meters = document.querySelector('.main_product-quantity_input') || document.querySelector('.quantity__input');
      if (!quantity_meters) return; // Exit if the element isn't found
      let measurement_value = parseFloat(quantity_meters.getAttribute('data-reference-value')) || 1;
      let current_qty = parseFloat(quantity_meters.value) || 1;
      let total_meters = Math.ceil(current_qty / measurement_value);
      let packet_price = parseFloat(quantity_meters.getAttribute('data-packet-price')) || 0;
      let packet_strike_price = parseFloat(quantity_meters.getAttribute('data-compare-at-price')) || 0;
      let total_packet_price = (packet_price * 1.19 * total_meters / 100).toFixed(2);
      let total_strike_price = (packet_strike_price * total_meters /100 - total_packet_price).toFixed(2);
      total_packet_price = total_packet_price.toString();
      total_strike_price = total_strike_price.toString();

      let totalMetersEl = document.querySelector('.saving-wrapper .total_meters');
      if (totalMetersEl) totalMetersEl.innerHTML = total_meters + ' ';

      let totalPacketPriceEl = document.querySelector('.saving-wrapper .total_packet_price');
      if (totalPacketPriceEl) totalPacketPriceEl.innerHTML = total_packet_price.replace('.', ',');

      let savingLine = document.querySelector('.saving-wrapper .saving');
      if (savingLine) {
        let spanEl = document.querySelector('.saving-wrapper .saving span');
        if (spanEl) spanEl.innerHTML = total_strike_price.replace('.', ',');
      }

      let totalMultipleEl = document.querySelector('.saving-wrapper .total_multiple');
      if (totalMultipleEl) {
        totalMultipleEl.innerHTML = total_meters > 1 ? 'Pakete' : 'Paket';
      }
    }
}
// *** Claculator 
const btnOpenCalculator = document.querySelector('.openCalculator');
const btnCloseCalculator = document.querySelector('.close_calculator');
btnOpenCalculator && btnOpenCalculator.addEventListener('click', openCalculator);
btnCloseCalculator && btnCloseCalculator.addEventListener('click', closeCalculator);
const calc_container = document.querySelector('.calculator_container');
function openCalculator(){
  setCalculatorHeight();
  setTimeout(()=>{
    calc_container.classList.add('open');
    document.querySelector('body').classList.add('calculator_container--open');
  },200)
  document.body.addEventListener('click', onBodyClickCalculator);
  document.querySelector('#shopify-section-header').classList.add('shopify-section-header-sticky', 'animate');
  document.querySelector('#shopify-section-header').classList.remove('shopify-section-header-hidden');
}
function setCalculatorHeight() {
  let topBar = document.getElementById("shopify-section-announcement-bar");
  let header = document.getElementById("shopify-section-header");
  let windowHeight = window.innerHeight ;
  let calculatorHeight;
   if (header.classList.contains('shopify-section-header-sticky')) {
      if (header.classList.contains('shopify-section-header-hidden')) {
          calculatorHeight = windowHeight - header.clientHeight ;
           console.log('1')
        }else{
          calculatorHeight = windowHeight - ( header.clientHeight + topBar.clientHeight);
          console.log('2')
        }
    }else{
     if(window.scrollY < topBar.clientHeight){
       calculatorHeight = windowHeight - ( header.clientHeight  + topBar.clientHeight )
     }else{
       calculatorHeight = windowHeight - ( header.clientHeight )
     }
    }
  calc_container.style.height = `${calculatorHeight}px`;
}
function onBodyClickCalculator(e){
  const hasClass = e.target.classList.contains('calculator_container') 
  if(!hasClass && e.target.classList.contains('transition-body')){
    closeCalculator()
  }
}
function closeCalculator(){
   calc_container.classList.remove('open');
  document.querySelector('body').classList.remove('calculator_container--open');
  document.body.removeEventListener('click', onBodyClickCalculator);
}
// Animation Label
const calculator_input = document.querySelectorAll('.calculator-input');
calculator_input.forEach(function (ell) {
  // Callback function Panels Calculator
  ell.addEventListener('input', calculatePanels);
  // Label Animation On focus
  ell.addEventListener('focus', function() {
    ell.closest('.input-wrapper').classList.add('focused-in');
  });
  ell.addEventListener('focusout', function() { 
    if(ell.value.length < 1 ){
      ell.closest('.input-wrapper').classList.remove('focused-in');
    }
  });
});
// Panels Calcul Logic
const checkBox_buffer = document.querySelector('#calculator_buffer_checkbox');
const ref_val = 1 || parseFloat(document.querySelector(".calculator-inputs").dataset.refValue);
const calculatedResult_btn = document.querySelector(".calculated-result");
// If the check box is updated, the result will be revised.
checkBox_buffer && checkBox_buffer.addEventListener('click', calculatePanels);
// Calculation Function
function calculatePanels() {
  const width_val = parseFloat(document.querySelector("#width-calc").value);
  const height_val = parseFloat(document.querySelector("#height-calc").value);
  let wall_size;
  let result;
  document.getElementById('kalkulator-ergebnis').innerHTML = '';
  if( !Number.isNaN(height_val) && !Number.isNaN(width_val)){
    // wall size metre cube
    wall_size = (width_val * height_val)/10000;
    if (checkBox_buffer.checked){
      let buffed_wallSize = (0.1 * wall_size) + wall_size;
      result =  buffed_wallSize / ref_val;
    }else{
      result = wall_size / ref_val;
    }
    if(!Number.isNaN(result)){
      calculatedResult_btn.innerHTML = `auswählen ${Math.ceil(result)} Stück`
      // Activate the button add
      calculatedResult_btn.removeAttribute('disabled'); 
      calculatedResult_btn.setAttribute('data-qty', Math.ceil(result));
    }else{
       calculatedResult_btn.innerHTML = `Fehler in der Berechnung`
    }
    if (Math.ceil(result)) {
      document.getElementById('kalkulator-ergebnis').innerHTML = 'Du benögst <b>'+ Math.ceil(result) +' m<sup>2</sup></b>';
    }
  }else{
    calculatedResult_btn.innerHTML = `auswählen`;
    calculatedResult_btn.setAttribute('disabled', true)
    calculatedResult_btn.setAttribute('data-qty', '')
  }
}
calculatedResult_btn.addEventListener('click', (e) => {
  // console.log(e.target.dataset.qty)
  document.querySelector('.quantity__input').value =  e.target.dataset.qty;
  document.querySelector('.real_quantity__input').value =  e.target.dataset.qty;
  change_packet_info();
  closeCalculator();
  calculator_input.forEach((ell)=>{
    ell.value = ''
  })
})

window.addEventListener('load', function() {
  window.scrollTo(0, window.scrollY + 1); setTimeout(() => window.scrollTo(0, window.scrollY - 1), 0);
})

window.customm2 = async function(event, { variantId, quantity }) {
  var par = event.target.parentElement.parentElement;
  var el = par.getElementsByClassName('quantity__input')[0];
  var key = par.getAttribute('data-key');

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });

  
  el.value = 1;
  el.dispatchEvent(new Event('change', { bubbles: true }));
}
// Update data-reference-value on variant change
function updateVariantPacketData() {

  var variantForm = document.querySelector('variant-radios, variant-selects');
  if (!variantForm) return;

  var variantsData = variantForm.querySelector('script[type="application/json"]');
  if (!variantsData) return;

  var variants = JSON.parse(variantsData.textContent);

  var selectedVariantId = document.querySelector('input[name="id"]')?.value;

  if (!selectedVariantId) return;

  var matchedVariant = variants.find(function(v) {
    return v.id == selectedVariantId;
  });

  if (!matchedVariant) return;

  var qtyInput = document.querySelector('.main_product-quantity_input');
  if (!qtyInput) return;


  var refValue = (
    matchedVariant.unit_price_measurement &&
    matchedVariant.unit_price_measurement.quantity_value
  )
  ? matchedVariant.unit_price_measurement.quantity_value
  : 1;


  qtyInput.setAttribute('data-reference-value', refValue);
  qtyInput.setAttribute('data-packet-price', matchedVariant.price);
  qtyInput.setAttribute('data-compare-at-price', matchedVariant.compare_at_price || 0);

  change_packet_info();
}


// Variant change
document.addEventListener('change', function(e) {

  var variantForm = e.target.closest('variant-radios, variant-selects');

  if (!variantForm) return;

  setTimeout(function(){
    updateVariantPacketData();
  }, 200);

});


// Initial page load with URL variant
document.addEventListener('DOMContentLoaded', function() {

  setTimeout(function(){
    updateVariantPacketData();
  }, 500);

});

// switching (which replaces the price HTML from the server), and re-apply
document.addEventListener('DOMContentLoaded', function () {
  var priceContainers = document.querySelectorAll('[id^="price-"]');

  priceContainers.forEach(function (container) {
    var observer = new MutationObserver(function () {
      // Disconnect first so our own innerHTML updates inside change_packet_info()
      // don't re-trigger this same observer (infinite loop guard).
      observer.disconnect();
      change_packet_info();
      observer.observe(container, { childList: true, subtree: true });
    });

    observer.observe(container, { childList: true, subtree: true });
  });
});
